export const home = {
  introduction: {
    title: 'INTRODUCTION',
    subTitle: 'FINTECHATHON',
    intro: [
      'WeBank’s fintech university competition, is one of the most influential events of its kind facing university talents. The event is committed to promoting the development of cutting-edge technologies like AI and blockchain, encouraging and helping domestic and overseas university students to explore fintech innovation, facilitating communications between relevant disciplines of universities and enterprises, and boosting innovation, practice, and career advancement competences of participating students.',
      'WeBank’s first university fintech competition had launched smoothly in 2019 with 178 teams from domestic and overseas universities. Finally, 3 shortlisted teams stood out respectively for AI and Blockchain, winning a prize of 500,000 CNY and opportunity for internship in WeBank. The Second FinTechathon starts with a brand-new online competition mode. We are waiting for you！ '
    ],
    poster: require('@/assets/img/review/1.png'),
    video: 'http://1258566428.vod2.myqcloud.com/2056e5f1vodcq1258566428/d85601da5285890806895526384/MYQ65jOPJp8A.mp4'
  },

  bars: [
    {
      name: 'INTRO',
      id: '#introduction'
    },
    {
      name: 'SUBJECTS',
      id: '#note'
    },
    {
      name: 'AGENDA',
      id: '#schedule'
    },
    {
      name: 'AWARDS',
      id: '#prize'
    },
    {
      name: 'ADVISOR',
      id: '#judge'
    },
    {
      name: 'JUDGES',
      id: '#saidaojudge'
    },
    {
      name: 'REVIEW',
      id: '#review'
    }
  ],

  nav: [
    {
      title: 'Introduction',
      name: 'Home',
      id: 0,
      active: true
    },
    {
      title: 'Competition Rules',
      name: 'Rule',
      id: 1,
      active: false
    },
    {
      title: 'Competition Works',
      name: 'Works',
      id: 2
    },
    {
      title: 'Technical Support',
      name: 'support',
      id: 3
    }
    // {
    //   title: '精彩回顾',
    //   name: 'join',
    //   id: 4
    // }
  ],

  note: [
    {
      type: 'ai',
      logo: 'https://static001.geekbang.org/resource/image/44/f7/44cfe8f0a4623f4e558331605cd441f7.png',
      title: 'Artificial Intelligence',
      link: {
        type: 'out',
        word: 'Caiwei Platform',
        title: '敬请期待',
        // wordIcon: require('@/assets/img/icon-jiantou.png'),
        wordIcon: require('@/assets/img/icon-sanjiao.png'),
        isValid: true,
        val: [
          {
            name: 'Please make the registration for the competition firstly, and then register on Caiwei Platform, ensuring the information provided is consistent. Otherwise, it will be deemed as invalid.<br />Entrance To Caiwei Platform>',
            link: 'https://wes.webank.com/webank-ai/competition-official-website/#/'
          }
        ]
      },
      intro: 'WeBank Caiwei Competition Platform, based on the form of AI competition, aims to the research of cutting-edge issues in financial scenarios, which is equipped with multiple functions including topic update, result submission, real-time ranking of competition, etc. Develop Financial anti-fraud model attack operation under the scenario of face recognition based on this competition platform.',
      introbg: require('@/assets/img/border_bottom.png'),
      q: [
        {
          title: 'Reference topic',
          intro: 'The accuracy and safety of face liveness is much of importance for financial industry. Motivated by profit, face liveness has often suffered a malicious attack with many styles of attacking modes. There is one type of attack technology called adversarial examples in the field of deep learning, which is generated by adding a small but worst-case perturbation on input examples, such that the perturbed input results in the model outputting an incorrect answer with high confidence. For example, in face liveness, attacker tries to make the model recognize the same person from two photos with two different people by fabricating attack examples. \nThis competition is to simulate black box attack mode under the scenario of face recognition, namely, participants conduct the attack without knowing the detail of model. Participants are required to add the way of disturbance for designated sample to make face recognition mode output false results and ensure the disturbance between adversarial examples and original examples as small as possible. '
        }
      ]
    },
    {
      type: 'blockchain',
      logo: 'https://static001.geekbang.org/resource/image/04/40/047be085787327ff01d42f42f47a6540.png',
      title: 'Blockchain',
      link: {
        type: 'in',
        word: 'Platform Links',
        wordIcon: require('@/assets/img/icon-sanjiao.png'),
        isValid: true,
        val: [
          {
            name: 'FISCO BCOS underlying platform',
            link: 'https://github.com/FISCO-BCOS/FISCO-BCOS'
          },
          {
            name: 'WeBASE middleware platform',
            link: 'https://github.com/WeBankFinTech/WeBASE'
          },
          {
            name: 'WeIdentity distributed identity management',
            link: 'https://github.com/WeBankFinTech/WeIdentity'
          },
          {
            name: 'WeEvent messaging collaboration',
            link: 'https://github.com/WeBankFinTech/WeEvent'
          },
          {
            name: 'WeCross General Cross-chain',
            link: 'https://github.com/WeBankFinTech/WeCross'
          },
        ]
      },
      intro: 'Design and develop a blockchain system based on FISCO BCOS and related open source solutions including WeBASE middleware, WeCross General cross-chain, Weldentity digital identity management and WeEvent Messaging collaboration without restrictions on industry and scenario to solve practical issues. ',
      introbg: require('@/assets/img/border_bottom_2.png'),
      q: [
        {
          title: 'Reference topic (including but not limited to the following three topics)',
          intro: 'Make continuous return and motivation for positive and civilized behaviors, especially for the appreciation, recording, encouragement and continuous affirmation of the tiny and positive behaviors. For example, develop effective motivation or awards for behaviors like return money found, garbage sorting and righteous and courageous to raise the level of social governance and promote social civilization development as a way to realize the sustainable development goals. Design a blockchain system with multiple participant roles to rationally measure public welfare behaviors under the condition of legal compliance, making public warfare behaviors realize the links including issuing, distribution, sponsorship, redeem records, clearing and supervision on the chain. '
        },
        {
          title: 'Reference topic (including but not limited to the following three topics)',
          intro: 'With the rapid development of blockchain technology, the blockchain application has been put into use in multiple industries and scenarios. Meanwhile, there is island effect between application and data. For example, there are several supply-chain financial blockchain platforms in the current market by the fact that data can be shared on the same platform but data on the different platforms is hard to （proceed） mutual trust and communication. In this connection, design a blockchain system by using WeCross General cross-chain open source platform to make data on different platforms realize mutual trust and communication. '
        },
        {
          title: 'Reference topic (including but not limited to the following three topics)',
          intro: 'It is requested to provide various evidentiary materials for matters related to real estate transaction, point-based household registration, admission scheme for the children of migrant workers, marriage registration, application for enterprise registration, etc. Design a blockchain system to store the data and evidence information on the chain including electronic contract, electronic certificate, housing transaction file query and certification to shorten the processing time as a way to realize “reduction in materials, links, time limit and times”. '
        },
      ]
    }
  ],

  judgeSaidao: [
    {
      type: 'ai',
      logo: 'https://static001.geekbang.org/resource/image/44/f7/44cfe8f0a4623f4e558331605cd441f7.png',
      title: 'Artificial Intelligence',
      mainJudge: {
        img: require('@/assets/img/14.png'),
        name: 'YANG Qiang',
        conTitle: 'Chairman of Judges',
        position: 'Chief Artificial Intelligence Officer，WeBank <br /> Chair Professor, Department of Computer Science and Engineering, HKUST',
        borderBg: require('@/assets/img/border_bottom.png'),
        bgColor: '#191837',
      },
      Judgers: {
        title: 'Expert Judges',
        subTitle: '（Listed in alphabetical order）',
        borderBg: require('@/assets/img/border_bottom.png'),
        dataBg: require('@/assets/img/ai_saidao_intro.png'),
        data: [
          { name: 'Kai CHEN', position: 'Professor, Department of Computer Science and Engineering, The Hong Kong University of Science and Technology' },
          { name: 'CHEN Tianjian', position: 'Deputy Manager & Expert Engineer of AI Group, WeBank' },
          { name: 'CHEN Yiqiang', position: 'Researcher, Institute of Computing Technology, Chinese Academy of Sciences' },
          { name: 'FAN Lixin', position: 'Chief Scientist of Artificial Intelligence, WeBank' },
          { name: 'Sinno PAN', position: 'Professor, School of Computer Science and Engineering, Nanyang Technological University, Singapore' },
          { name: 'PAN Weike', position: 'Professor, College of Computer Science & Software Engineering, Shenzhen University' },
          { name: 'TANG Jie', position: 'Professor, Department of Computer Science and Technology, Tsinghua University\n Named Professor, WeBank' },
          { name: 'TONG Yongxin', position: 'Professor, School of Computer Science and Engineering, Beihang University' },
          // { name: '王文博', position: '香港科技大学市场学系终身教授、博士生导师' },
          { name: 'XI Wei', position: 'Professor, Department of Computing Science and Technology, Xi’an Jiaotong University' },
          { name: 'YU Han', position: 'Professor, School of Computer Science and Engineering, Nanyang Technological University, Singapore' },
          { name: 'ZHENG Wenchen', position: 'Deputy Manager & Expert Engineer of AI Group, WeBank' }
        ]
      }
    },
    {
      type: 'blockchain',
      logo: 'https://static001.geekbang.org/resource/image/04/40/047be085787327ff01d42f42f47a6540.png',
      title: 'Blockchain',
      mainJudge: {
        img: require('@/assets/img/15.png'),
        name: 'MA Zhitao',
        conTitle: 'Chairman of Judges',
        position: 'Vice President & Chief Information Officer, WeBank',
        borderBg: require('@/assets/img/border_bottom_2.png'),
        bgColor: '#4C0A27',
      },
      Judgers: {
        title: 'Expert Judges',
        subTitle: '（Listed in alphabetical order）',
        borderBg: require('@/assets/img/border_bottom_2.png'),
        dataBg: require('@/assets/img/blockchain_saidao_intro.png'),
        data: [
          { name: 'CHEN Lei', position: 'Professor, The Hong Kong University of Science and Technology\nPresident, ACM Hong Kong' },
          { name: 'FAN Ruibin', position: 'Deputy Manager of Distributed Commercial Technology Development Department, Blockchain Principal, WeBank\nGolden Chain Alliance Open Source Working Group Leader' },
          { name: 'HE Debiao', position: 'Professor, Wuhan University\nStanding Committee Member, CCF Technical Committee on Blockchain' },
          { name: 'JIN Hai', position: 'Professor, Huazhong University of Science and Technology\nDeputy President, China Computer Federation' },
          { name: 'LEI Kai', position: 'Distinguished researcher, Peking University Shenzhen Graduate School\nStanding Committee Member, CCF Technical Committee on Blockchain' },
          { name: 'PEI Qingqi', position: 'Professor, Xidian University\nExecutive Director，Shanxi Key Laboratory of Blockchain and Secure Computing' },
          { name: 'PENG Shaoliang', position: 'Professor, Hunan University\n Deputy Director, National Supercomputing Center in Changsha' },
          { name: 'SI Xueming', position: 'Professor, Fudan University\nDirector, CCF Technical Committee on Blockchain' },
          { name: 'SUN Yi', position: 'Researcher, Institute of Computing Technology Chinese Academy of Sciences\nDeputy Director of CCF Technical Committee on Blockchain' },
          { name: 'WU Qianhong', position: 'Deputy-Dean, Professor, School of Cyberspace Security，Beihang University\nStanding Committee Member, CCF Technical Committee on Blockchain' },
          { name: 'ZHANG Kaixiang', position: 'Chief Architect of Blockchain, WeBank' },
          { name: 'ZHAO Gansen', position: 'Vice-dean & Professor, School of Computer Science, South China Normal University\nMember of GDCA Technical Committee on Blockchain' },
          { name: 'ZHENG Zibin', position: 'Dean & Professor, Department of Software Engineering, Sun Yat-Sen University\nDeputy Director of GDCA Technical Committee on Blockchain' },
          { name: 'ZHU Liehuang', position: 'Deputy-Dean, Professor, Beijing Institute of Technology\nSecretary General,CCF Technical Committee on Blockchain\nDirector，Blockchain Engineering Committee of new Engineering Alliance' }
        ]
      }
    }
  ],

  review: {
    btn: {
      link: 'https://fintech.webank.com/past-events/fintechathon-2019/',
      name: '2019 Review'
    },
    left: {
      poster: require('@/assets/img/video_img.png'),
      video: 'http://1258566428.vod2.myqcloud.com/2056e5f1vodcq1258566428/a0e904b15285890806028324769/tI6SMGAAHVgA.mp4'
    },
    right: [
      {
        img: require('@/assets/img/review/1.jpg'),
        link: '',
        h3: '2019 FinTechathon WeBank • the First Fintech University Technology Competition'
      },
      {
        img: require('@/assets/img/review/2.jpg'),
        link: '',
        h3: 'The first prize of AI was presented by Yang Qiang, Chairman of judges for AI and Ma Zhitao, Chairman of judges for blockchain. '
      },
      {
        img: require('@/assets/img/review/3.jpg'),
        link: '',
        h3: 'The first prize of Blockchain was presented by Yang Qiang, Chairman of judges for AI and Ma Zhitao, Chairman of judges for blockchain.'
      },
      {
        img: require('@/assets/img/review/4.jpg'),
        link: '',
        h3: 'On 26 August 2019, Award Ceremony of WeBank • the First Fintech University Technology Competition'
      },
      {
        img: require('@/assets/img/review/5.jpg'),
        link: '',
        h3: 'On 26 August 2019, Award Ceremony of WeBank • the First Fintech University Technology Competition '
      },
      {
        img: require('@/assets/img/review/6.jpg'),
        link: '',
        h3: 'On 26 August 2019, Brett King delivered a wonderful sharing named “Future Bank 4.0”'
      },
      {
        img: require('@/assets/img/review/7.jpg'),
        link: '',
        h3: 'On 24-25, August 2019, Hackathon Competition Scene'
      },
      {
        img: require('@/assets/img/review/8.jpg'),
        link: '',
        h3: 'Explanations and problem-solving have made by technical support expert of AI to participants.'
      },
      {
        img: require('@/assets/img/review/9.jpg'),
        link: '',
        h3: 'Explanations and problem-solving have made by technical support expert of blockchain to participants. '
      },
      {
        img: require('@/assets/img/review/10.jpg'),
        link: '',
        h3: 'Roadshow presentation has made by AI participants'
      },
      {
        img: require('@/assets/img/review/11.jpg'),
        link: '',
        h3: 'Roadshow presentation has made by Blockchain participants'
      },
      {
        img: require('@/assets/img/review/12.jpg'),
        link: '',
        h3: 'On 26 August 2019, Award Ceremony Scene of WeBank • the First Fintech University Technology Competition'
      }
    ]
  },

  partners: [
    {
      title: 'Sponsor',
      logoList: [
        require('@/assets/img/webank.png'),
      ]
    },
    {
      title: 'Co-sponsor',
      logoList: [
        require('@/assets/img/shenda.png')
      ]
    },
    {
      title: 'Co-organizer',
      logoList: [
        require('@/assets/img/as.png'),
        require('@/assets/img/aiti.png'),
        require('@/assets/img/jinlianmeng.png'),
        require('@/assets/img/pengcheng.png'),
      ]
    },
    {
      title: 'Technical Support',
      logoList: [
        require('@/assets/img/dianzi.png'),
        // require('@/assets/img/jisuanji.png'),
        require('@/assets/img/beida.png'),
      ]
    },
    {
      title: 'Partner',
      logoList: [
        require('@/assets/img/geekbang.png'),
        require('@/assets/img/infoq.png'),
      ]
    }
  ],

  schedule: {
    title: {
      h1: 'AGENDA',
      titleBg: require('@/assets/img/title-bg.png')
    },
    subTitle: 'The competition is made online including primary phase, the finals .',
    timeLine: [
      {
        time: '10 August',
        desc: 'Start of Registration'
      },
      {
        time: '9 October',
        desc: 'Deadline for Submission of Works for the Preliminaries'
      },
      {
        time: '12 October',
        desc: 'Announcement of Shortlisted for the Finals'
      },
      {
        time: '23 October',
        desc: 'Deadline for Submission of Works for the Finals'
      },
      {
        time: '24 October',
        desc: 'Final Works Presentation'
      },
      {
        time: '29 October',
        desc: 'Final Results Announcement and Award Ceremony'
      }
    ]
  },

  prize: {
    title: {
      h1: 'AWARDS',
      titleBg: require('@/assets/img/title-bg.png')
    },
    desc: 'The results will be reviewed by the competition Expert Committee and published on the official website of the competition. The certificate will be printed and issued by the competition organizing committee. In the finals, the first, second and third prize winners will be awarded with certificates and prizes (before tax) according the final ranking.',
    prizes: [
      {
        type: 'ai',
        title: 'Artificial Intelligence (AI)',
        list: [
          {
            img: require('@/assets/img/price_1.png'),
            price: '100,000',
            text: 'The First Prize'
          },
          {
            img: require('@/assets/img/price_2.png'),
            price: '80,000',
            text: 'The Second Prize'
          },
          {
            img: require('@/assets/img/price_3.png'),
            price: '50,000',
            text: 'The Third Prize'
          }
        ]
      },
      {
        type: 'block',
        title: 'Blockchain ',
        list: [
          {
            img: require('@/assets/img/price_1.png'),
            price: '100,000',
            text: 'The First Prize'
          },
          {
            img: require('@/assets/img/price_2.png'),
            price: '80,000',
            text: 'The Second Prize'
          },
          {
            img: require('@/assets/img/price_3.png'),
            price: '50,000',
            text: 'The Third Prize'
          }
        ]
      },
      {
        type: 'good',
        title: 'Benefits for Excellent Participants',
        list: [
          {
            img: require('@/assets/img/1.png'),
            price: '',
            text: 'Award certificates and trophies '
          },
          {
            img: require('@/assets/img/2.png'),
            price: '',
            text: 'Priorities for internship and employment opportunities'
          },
          {
            img: require('@/assets/img/4.png'),
            price: '',
            text: 'Opportunity for works promotion '
          },
          {
            img: require('@/assets/img/3.png'),
            price: '',
            text: 'Capital venture for excellent projects'
          },
          {
            img: require('@/assets/img/5.png'),
            price: '',
            text: 'Participation memorial prize'
          }
        ]
      }
    ]
  },

  judges: [
    {
      title: {
        // h1: 'Invited Honorary Advisor',
        h1: 'INVITED HONORARY ADVISOR',
        titleBg: require('@/assets/img/title-bg.png'),
        tip: '（Listed in alphabetical order）'
      },
      list: [
        {
          headImg: require('../../../assets/img/judges/1.png'),
          name: 'CHAI Hongfeng',
          title: 'Academician, Chinese Academy of Engineering<br/>Board Director, China UnionPay'
        },
        {
          headImg: require('../../../assets/img/judges/2.png'),
          name: 'GAO Wen',
          title: 'Academician, Chinese Academy of Engineering<br/>Professor, Peking University</br>Director, Peng Cheng Laboratory'
        },
        {
          headImg: require('../../../assets/img/judges/3.png'),
          name: 'RONG Chunming',
          title: 'Academician, Norwegian Academy of Engineering<br/>Tenured Professor，Department of Electrical Engineering and Computer Science，University of Stavanger<br/>Overseas Evaluation Expert，Chinese Academy of Sciences'
        },
        {
          headImg: require('../../../assets/img/judges/4.png'),
          name: 'XU Yangsheng',
          title: 'Academician, Chinese Academy of Engineering<br/>President, The Chinese University of Hong Kong, Shenzhen<br/>Chair Professor, The Chinese University of Hong Kong'
        }
      ]
    },
    {
      title: {
        // h1: 'Invited Academic Advisor',
        h1: 'INVITED ACADEMIC ADVISOR',
        titleBg: require('@/assets/img/title-bg.png'),
        tip: '（Listed in alphabetical order）'
      },
      list: [
        {
          headImg: require('../../../assets/img/judges/5.png'),
          name: 'Tim Kwang-Ting \nCHENG',
          title: 'Dean, School of Engineering, The Hong Kong University of Science and Technology'
        },
        {
          headImg: require('../../../assets/img/judges/6.png'),
          name: 'Irwin KING',
          title: 'Computer Science and Engineering Department Chairman & Professor, The Chinese University of Hong Kong'
        },
        {
          headImg: require('../../../assets/img/judges/7.png'),
          name: 'Yang WANG',
          title: 'Dean, School of Science, The Hong Kong University of Science and Technology'
        },
        {
          headImg: require('../../../assets/img/judges/8.png'),
          name: 'WU Qianhong',
          title: 'Deputy-Dean, Professor, School of Cyberspace Security，Beihang University<br/>Standing Committee Member, CCF Technical Committee on Blockchain'
        },
        {
          headImg: require('../../../assets/img/judges/9.png'),
          name: 'ZHOU Zhihua',
          title: 'Dean, School of Artificial Intelligence, Nanjing University <br/> Professor, Department of Computer Science and Technology'
        },
        {
          headImg: require('../../../assets/img/judges/10.png'),
          name: 'ZHU Liehuang',
          title: 'Deputy-Dean, Professor, Beijing Institute of Technology<br/>Secretary General,CCF Technical Committee on Blockchain<br/>Director，Blockchain Engineering Committee of new Engineering Alliance'
        }
      ]
    },
    // {
    //   title: {
    //     h1: '特邀行业顾问',
    //     titleBg: require('@/assets/img/title-bg.png'),
    //     tip: '（按姓氏首字母排序）'
    //   },
    //   list: [
    //     // {
    //     //   headImg: require('../../../assets/img/judges/11.png'),
    //     //   name: '黄宇铮',
    //     //   title: '博裕资本董事总经理'
    //     // },
    //     {
    //       headImg: require('../../../assets/img/judges/12.png'),
    //       name: '刘明',
    //       title: '鹏城实验室人工智能开源平台办公室主任<br/>OpenI启智新一代人工智能开源开放平台秘书处秘书长'
    //     }
    //     // {
    //     //   headImg: require('../../../assets/img/judges/13.png'),
    //     //   name: '钟惠馨',
    //     //   title: '麦肯锡全球董事、合伙人'
    //     // }
    //   ]
    // }
  ]
}
